import React, { useEffect } from "react";
import virus1 from "../../../Assets/Home/Common/virus1.png";
import virus2 from "../../../Assets/Home/Common/virus2.png";
import virus3 from "../../../Assets/Home/Common/virus3.png";
import virus4 from "../../../Assets/Home/Common/virus4.png";
import lab1 from "../../../Assets/Home/Lab/lab1.png";
import lab2 from "../../../Assets/Home/Lab/lab2.png";
import lab3 from "../../../Assets/Home/Lab/lab3.png";
import lab4 from "../../../Assets/Home/Lab/lab4.png";
import lab5 from "../../../Assets/Home/Lab/lab5.svg";

const LabSections = () => {
  const sections = [
    {
      title: "Clinical Biochemistry",
      desc: "Blood sugar, liver, kidney, lipid, and metabolic tests.",
      icon: <img src={lab1} size={30} />,
    },
    {
      title: "Hematology",
      desc: "CBC, coagulation profiles, and related tests.",
      icon: <img src={lab2} size={30} />,
    },
    {
      title: "Microbiology",
      desc: " Bacterial, viral, and fungal diagnostics.",
      icon: <img src={lab3} size={30} />,
    },
    {
      title: "Histopathology",
      desc: "Tissue and cell analysis for disease detection.",
      icon: <img src={lab4} size={30} />,
    },
    {
      title: "Molecular Diagnostics",
      desc: "Oncology, infectious diseases, and inherited conditions.",
      icon: <img src={lab5} size={30} />,
    },
  ];

  return (
    <div className="bg-[#fafafa]">
      {/* Main Section */}
      <div className="relative pt-20 xl:px-28 md:px-10 px-6">
        <img
          src={virus4}
          alt="decor"
          className="absolute top-10 left-20 w-16 h-16 animate-bounce-down pointer-events-none"
        />
        <img
          src={virus2}
          alt="decor"
          className="absolute bottom-20 right-10 w-16 h-16 animate-bounce-up pointer-events-none"
        />
        <img
          src={virus1}
          alt="decor"
          className="absolute top-10 right-10 w-16 h-16 animate-bounce-left pointer-events-none"
        />
        <img
          src={virus3}
          alt="decor"
          className="absolute bottom-10 left-10 w-16 h-16 animate-bounce-right pointer-events-none"
        />

        {/* Lab Cards */}
        <div className="grid md:grid-cols-2 grid-cols-1 lg:grid-cols-5 gap-8">
          {sections.map((section, index) => (
            <div
              data-aos="flip-down"
              // data-aos-offset="100"
              // data-aos-duration="700"
              key={index}
              className={`lab-card bg-white rounded-xl shadow-lg px-4 sm:px-3 md:px-5 py-2 sm:py-3 flex flex-col items-start hover:shadow-2xl ${index === 4 && "md:col-span-2 lg:col-span-1"
                } transition-all duration-300 ease-in-out`}
            >
              <div className="my-3 card-icon">{section.icon}</div>
              <h3 className="text-xl familjen-font font-semibold my-2 card-title">
                {section.title}
              </h3>
              <p className="text-sm md:text-[1rem] line-clamp-2 font-normal leading-relaxed text-[#5a5a5a] my-3 card-desc">
                {section.desc}
              </p>
            </div>
          ))}
        </div>
      </div>

      <div className="marquee-container py-6">
        <div className="marquee-content">
          <span className="uppercase text-[3rem] md:text-[6rem] lg:text-[8rem] font-bold tracking-widest text-gray-800 px-8">
            <span className="text-primaryColor pl-4">Diagnostic</span> Science{" "}
            <span className="text-primaryColor pr-20">Laboratory</span>
          </span>
          <span className="uppercase text-[3rem] md:text-[6rem] lg:text-[8rem] font-bold tracking-widest text-gray-800 px-8">
            <span className="text-primaryColor">Diagnostic</span> Science{" "}
            <span className="text-primaryColor">Laboratory</span>
          </span>
        </div>
      </div>
    </div>
  );
};

export default LabSections;
